var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hasSpecialProperty
    ? _c(
        "article",
        {
          staticClass: "cmp cmp-product-thumb",
          attrs: { "data-testing": _vm.item.variation.id }
        },
        [
          _c(
            "div",
            { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
            [
              _c("div", { staticClass: "thumb-image" }, [
                _c(
                  "div",
                  { staticClass: "prop-1-1" },
                  [
                    _vm._t("item-image", [
                      _c("category-image-carousel", {
                        ref: "categoryImageCarousel",
                        attrs: {
                          "image-urls-data": _vm._f("itemImages")(
                            _vm.item.images,
                            _vm.imageUrlAccessor
                          ),
                          alt: _vm._f("itemName")(_vm.item),
                          title: _vm._f("itemName")(_vm.item),
                          "item-url": _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          ),
                          "enable-carousel":
                            _vm.$ceres.config.item.enableImageCarousel,
                          "disable-carousel-on-mobile":
                            _vm.disableCarouselOnMobile
                        }
                      }),
                      _vm._v(" "),
                      _vm.energyLabelImage
                        ? _c("div", { staticClass: "energy-label my-2" }, [
                            _c("img", {
                              staticStyle: {
                                "max-width": "80px",
                                cursor: "pointer"
                              },
                              attrs: {
                                src: _vm.energyLabelImage,
                                alt: _vm.energyLabelValue
                              },
                              on: {
                                click: function($event) {
                                  _vm.showEnergyLabelModal = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.showEnergyLabelModal
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "modal fade show",
                                    staticStyle: {
                                      display: "block",
                                      background: "rgba(0,0,0,0.5)"
                                    },
                                    attrs: { tabindex: "-1" },
                                    on: {
                                      click: function($event) {
                                        if (
                                          $event.target !== $event.currentTarget
                                        ) {
                                          return null
                                        }
                                        _vm.showEnergyLabelModal = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-dialog modal-lg modal-dialog-centered"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "modal-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "modal-header" },
                                              [
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass: "modal-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "stabiloVueTheme::Single.EnergyLabelModalTitle"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "close",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showEnergyLabelModal = false
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      },
                                                      [_vm._v("×")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modal-body text-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    "max-width": "100%"
                                                  },
                                                  attrs: {
                                                    src:
                                                      _vm.energyLabelModalImage,
                                                    alt: "EnergieLabel"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "categoryitem-stoerer-wrapper" },
                  _vm._l(_vm.item.variationProperties, function(
                    propertyGroup,
                    groupIndex
                  ) {
                    return _c("div", { key: "group-" + groupIndex }, [
                      propertyGroup.property
                        ? _c("div", [
                            propertyGroup.property.id == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "categoryitem-sale small font-weight-bold text-white"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "stabiloVueTheme::Single.AdsOnly"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            propertyGroup.property.id == 12
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "categoryitem-onlineonly small font-weight-bold text-white"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "stabiloVueTheme::Single.OnlineOnly"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            propertyGroup.property.id == 13
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "categoryitem-storeonly small font-weight-bold text-white"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "stabiloVueTheme::Single.StoreOnly"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            propertyGroup.property.id == 14
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "categoryitem-temp small font-weight-bold text-white"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "stabiloVueTheme::Single.TempOnly"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _c(
                            "div",
                            _vm._l(propertyGroup.properties, function(
                              property,
                              propIndex
                            ) {
                              return _c(
                                "div",
                                { key: "prop-" + groupIndex + "-" + propIndex },
                                [
                                  property.id == 2
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "categoryitem-sale small font-weight-bold text-white"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "stabiloVueTheme::Single.AdsOnly"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  property.id == 12
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "categoryitem-onlineonly small font-weight-bold text-white"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "stabiloVueTheme::Single.OnlineOnly"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  property.id == 13
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "categoryitem-storeonly small font-weight-bold text-white"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "stabiloVueTheme::Single.StoreOnly"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  property.id == 14
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "categoryitem-temp small font-weight-bold text-white"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "stabiloVueTheme::Single.TempOnly"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm._t("store-special", [
                _vm.storeSpecial ||
                _vm.item.variation.bundleType === "bundle" ||
                _vm.item.item.itemType === "set"
                  ? _c("item-store-special", {
                      attrs: {
                        "store-special": _vm.storeSpecial,
                        "recommended-retail-price": _vm.item.prices.rrp,
                        "variation-retail-price": _vm.item.prices.default,
                        "special-offer-price": _vm.item.prices.specialOffer,
                        "decimal-count": _vm.decimalCount,
                        "bundle-type": _vm.item.variation.bundleType,
                        "item-type": _vm.item.item.itemType
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._t("item-details", [
                _c(
                  "div",
                  { staticClass: "thumb-content" },
                  [
                    _vm.item.item.manufacturer &&
                    _vm.item.item.manufacturer.externalName
                      ? _c("p", {
                          staticClass:
                            "mb-1 manufacturer text-uppercase text-muted small font-heading",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.item.item.manufacturer.externalName
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "thumb-title small",
                        class: {
                          "stretched-link":
                            _vm.$ceres.config.global.shippingCostsCategoryId ==
                            0
                        },
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm._f("itemName")(_vm.item))
                        ),
                        _vm._l(_vm.item.groupedAttributes, function(
                          attribute,
                          index
                        ) {
                          return _c("span", { key: "attr-" + index }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Ceres::Template.itemGroupedAttribute",
                                  attribute
                                )
                              )
                            )
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "hr-dark my-2" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "categoryitem-produktdatenblatt small" },
                      [
                        _vm.item.variationProperties
                          ? [
                              _vm._l(_vm.item.variationProperties, function(
                                property,
                                index
                              ) {
                                return [
                                  property.properties
                                    ? [
                                        _vm._l(property.properties, function(
                                          prop,
                                          propIndex
                                        ) {
                                          return [
                                            prop.id == 44
                                              ? _c(
                                                  "a",
                                                  {
                                                    key:
                                                      "prop-" +
                                                      index +
                                                      "-" +
                                                      propIndex,
                                                    attrs: {
                                                      href: prop.values.value,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Produktdatenblatt »"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        })
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  property.property &&
                                  property.property.id == 44
                                    ? _c(
                                        "a",
                                        {
                                          key: "single-prop-" + index,
                                          attrs: {
                                            href: property.values.value,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("Produktdatenblatt »")]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "thumb-meta mt-2 d-flex flex-column align-items-start"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _vm._t("before-prices"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "feedback-stars-count" },
                              [
                                _vm.item.item.feedbackCount > 0
                                  ? _c("div", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.item.item.feedbackCount) +
                                          ")"
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "prices d-flex flex-row-reverse" },
                          [
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.price.value
                              ? _c("div", { staticClass: "price-view-port" }, [
                                  _vm.item.prices.specialOffer
                                    ? _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("itemCrossPrice")(
                                                _vm.item.prices.default
                                                  .unitPrice.formatted,
                                                true
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("itemCrossPrice")(
                                                _vm.item.prices.rrp.unitPrice
                                                  .formatted
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "price mr-1",
                                class: { "has-crossprice": _vm.hasCrossPrice }
                              },
                              [
                                _vm.item.item.itemType === "set"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemSetPrice",
                                              { price: _vm.itemSetPrice }
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFootnote"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  : _vm.itemGraduatedPriceisCheapestSorting
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFromPrice",
                                              { price: _vm.itemPriceGraduated }
                                            )
                                          ) +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFootnote"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  : _vm.itemGraduatedPricesalableVariationCount
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFromPrice",
                                              { price: _vm.itemPriceGraduated }
                                            )
                                          ) +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFootnote"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("specialOffer")(
                                              _vm.item.prices.default.unitPrice
                                                .formatted,
                                              _vm.item.prices,
                                              "unitPrice",
                                              "formatted"
                                            )
                                          ) +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemFootnote"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._t("after-prices"),
                    _vm._v(" "),
                    _vm.item.prices.default.lowestPrice.value &&
                    _vm.hasCrossPrice
                      ? _c(
                          "div",
                          { staticClass: "category-lowest-price small" },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemLowestPrice",
                                    {
                                      price:
                                        _vm.item.prices.default.lowestPrice
                                          .formatted
                                    }
                                  )
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !(
                      _vm.item.unit.unitOfMeasurement === "C62" &&
                      _vm.item.unit.content === 1
                    )
                      ? _c(
                          "div",
                          { staticClass: "category-unit-price small" },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                            ]),
                            _vm._v(" "),
                            _vm.item.variation.mayShowUnitPrice
                              ? _c("span", [
                                  _vm._v(" | " + _vm._s(_vm.basePrice))
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ])
            ],
            2
          )
        ]
      )
    : _c(
        "article",
        {
          staticClass: "cmp cmp-product-thumb top-deal p-3",
          attrs: { "data-testing": _vm.item.variation.id }
        },
        [
          _c(
            "a",
            {
              staticClass: "d-flex flex-wrap h-100",
              attrs: {
                href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "special-text w-100 align-items-center d-flex justify-content-around"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-white p-2 bg-danger h4 font-weight-bold font-heading"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("stabiloVueTheme::Catview.SpecialText")
                        )
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "title font-weight-bold d-block text-dark px-3 font-heading"
                },
                [
                  _vm._v("\n      " + _vm._s(_vm._f("itemName")(_vm.item))),
                  _vm._l(_vm.item.groupedAttributes, function(
                    attribute,
                    index
                  ) {
                    return _c("span", { key: "attr-" + index }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("translate")(
                            "Ceres::Template.itemGroupedAttribute",
                            attribute
                          )
                        )
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm._t("item-details", [
                _c(
                  "div",
                  { staticClass: "d-flex flex-wrap w-100 price-img-wrap" },
                  [
                    _c(
                      "div",
                      { staticClass: "img text-center" },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "image-url":
                              _vm.item.images &&
                              _vm.item.images.all &&
                              _vm.item.images.all[0]
                                ? _vm.item.images.all[0].urlPreview ||
                                  _vm.item.images.all[0].urlMiddle
                                : "",
                            "picture-class": "img-fluid"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "prices d-flex flex-column justify-content-center align-items-end pb-3 pb-md-0"
                      },
                      [
                        _vm.item.prices.rrp &&
                        _vm.item.prices.rrp.price.value > 0 &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.price.value
                          ? _c("div", [
                              _vm.item.prices.specialOffer
                                ? _c("del", { staticClass: "h5 text-dark" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            true
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                : _c("del", { staticClass: "h5 text-dark" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "price mr-1",
                            class: { "has-crossprice": _vm.hasCrossPrice }
                          },
                          [
                            _vm.item.item.itemType === "set"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          { price: _vm.itemSetPrice }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              : _vm.itemGraduatedPriceisCheapestSorting
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              : _vm.itemGraduatedPricesalableVariationCount
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("specialOffer")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          _vm.item.prices,
                                          "unitPrice",
                                          "formatted"
                                        )
                                      ) +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            2
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }